import { render, staticRenderFns } from "./dailyRecord.vue?vue&type=template&id=64d99a9b&scoped=true"
import script from "./dailyRecord.vue?vue&type=script&lang=js"
export * from "./dailyRecord.vue?vue&type=script&lang=js"
import style0 from "./dailyRecord.vue?vue&type=style&index=0&id=64d99a9b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d99a9b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64d99a9b')) {
      api.createRecord('64d99a9b', component.options)
    } else {
      api.reload('64d99a9b', component.options)
    }
    module.hot.accept("./dailyRecord.vue?vue&type=template&id=64d99a9b&scoped=true", function () {
      api.rerender('64d99a9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dailyRecordBox/dailyRecord/dailyRecord.vue"
export default component.exports